<template>
  <div>
    <PageHeader title="หวยตัวอย่าง รอบวันที่" />

    <LottoDemoForm />
    <template v-if="lottoDemo">
      <LottoDemoBetList :id="lottoDemo.id" />
    </template>
  </div>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import LottoDemoBetList from '@components/lotto-demo/bet-list.vue';

export default {
  components: {
    LottoDemoBetList,
    LottoDemoForm: () => import('@components/lotto-demo/form'),
  },
  computed: {
    ...mapState({
      lottoDemo: (state) => state['lotto-demo'].currentRound,
    }),
  },
  created() {
    this.fetchCurrentLottoDemo()
  },
  methods: {
    ...mapActions(['fetchCurrentLottoDemo'])
  }
}
</script>
